import React from 'react'
import "./loader.css"
const Loader = () => {
    return (
        <div className='loaderpage'>
            <div className='loader'>
                <h1 className='rahul'>RAHUL</h1>
                
                <h1 className='bishnoi'>BISHNOI</h1>
            </div>
        </div>
    )
}

export default Loader